import { CloseEditorIfOpenedEvent } from '../BuilderController';
import { BuilderFeatures } from '../BuilderFeatures';
import { BUILDER_BLOCK_SKILLS_COPIED, BUILDER_BLOCK_SKILLS_SIDEBAR_CLOSE, } from './PreparedBlocksSegmentEvents';
import welcome from './resources/welcome.json';
import numbersMenu from './resources/numbersMenu.json';
import buttonsMenu from './resources/buttonsMenu.json';
import brDocumentValidation from './resources/brDocumentValidation.json';
import brLeadRegistration from './resources/brLeadRegistration.json';
import shortNPSSurvey from './resources/shortNPSSurvey.json';
import longNPSSurvey from './resources/longNPSSurvey.json';
import CSATSurvey from './resources/CSATSurvey.json';
import attendanceSatisfactionSurvey from './resources/attendanceSatisfactionSurvey.json';
import './PreparedBlocksSidebar.scss';
export class PreparedBlocksSidebarController {
    static $inject = ['close', 'clipboard', '$rootScope', '$translate', '$timeout', 'SegmentService', 'BlipToastService', 'application'];
    constructor(close, clipboard, $rootScope, $translate, $timeout, SegmentService, BlipToastService, application) {
        'ngInject';
        this.close = close;
        this.clipboard = clipboard;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.application = application;
        this.preparedBlocksList = [];
        this.copyBlocksToClipboard = (index) => {
            this.preparedBlocksList = this.preparedBlocksList.map(block => ({
                ...block,
                copying: false,
            }));
            this.preparedBlocksList[index].copying = true;
            this.clipboard.copyText(JSON.stringify(this.preparedBlocksList[index].resource));
            this.SegmentService.createApplicationTrack({
                trackEvent: BUILDER_BLOCK_SKILLS_COPIED,
                application: this.application,
                payload: {
                    blockName: this.preparedBlocksList[index].title,
                },
            });
            this.$timeout(async () => {
                this.BlipToastService.show('info', {
                    title: await this.$translate('preparedBlocks.successToast.title'),
                    msg: await this.$translate('preparedBlocks.successToast.message'),
                    icon: 'message-ballon',
                    duration: 3000,
                });
            }, 600);
            this.$timeout(() => {
                this.preparedBlocksList[index].copying = false;
                this.$rootScope.$apply();
            }, 3000);
        };
        this.init();
    }
    async init() {
        let resources = {
            welcome,
            numbersMenu,
            buttonsMenu,
            brDocumentValidation,
            brLeadRegistration,
            shortNPSSurvey,
            longNPSSurvey,
            CSATSurvey,
        };
        const isDeskSurveyFeatureEnabled = await BuilderFeatures.isBuilderPreparedBlockDeskSurveyEnabled();
        if (isDeskSurveyFeatureEnabled) {
            resources = { ...resources, ...{ attendanceSatisfactionSurvey } };
        }
        const blocksIds = Object.keys(resources);
        for (const id of blocksIds) {
            const trlPrefix = `preparedBlocks.options.${id}`;
            this.preparedBlocksList.push({
                title: await this.$translate(`${trlPrefix}.title`),
                description: await this.$translate(`${trlPrefix}.description`),
                resource: resources[id],
            });
        }
    }
    async closeSidebar() {
        try {
            this.$rootScope.$broadcast(CloseEditorIfOpenedEvent);
            this.SegmentService.createOrganizationTrack(BUILDER_BLOCK_SKILLS_SIDEBAR_CLOSE);
            await this.close();
        }
        catch (e) {
            console.error(e);
        }
    }
}
PreparedBlocksSidebarController.$inject = ['close', 'clipboard', '$rootScope', '$translate', '$timeout', 'SegmentService', 'BlipToastService', 'application'];
